import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onClick", "children", "isDropdownItem", "isActive", "href", "twStyle", "testId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useNavigationContext } from '@restworld/utils-common';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * A button component that is anchor element inside.
 *
 * @param onClick - The click event handler for the button.
 * @param children - The content to be displayed inside the button.
 * @param isDropdownItem - A boolean indicating whether the button is a dropdown item.
 * @param isActive - A boolean indicating whether the button is currently active.
 * @param href - The URL to navigate to when the button is clicked.
 * @param twStyle - The Tailwind CSS styles to apply to the button.
 * @param rest - The rest of the props like ref, target, as to be passed to the button.
 * @example
 * <NavigationButton
      isActive={active}
      isDropdownItem
      onClick={(e) => {
        if (v.key === 'open-intercom') {
          e.preventDefault();
          showIntercom();
        }
      }}
      {...{
        href: v.url,
        target: v.openOnNewTab ? '_blank' : '_self',
        rel: v.openOnNewTab ? 'noopener noreferrer' : '',
      }}
    >
      {v.label}
    </NavigationButton>
 */
export var NavigationButton = function NavigationButton(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      isDropdownItem = _ref.isDropdownItem,
      isActive = _ref.isActive,
      href = _ref.href,
      twStyle = _ref.twStyle,
      testId = _ref.testId,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      isHover = _useState[0],
      setIsHover = _useState[1];

  var _useNavigationContext = useNavigationContext(),
      Link = _useNavigationContext.linkComponent;

  return /*#__PURE__*/_jsxs("div", {
    onMouseEnter: function onMouseEnter() {
      return setIsHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHover(false);
    },
    children: [/*#__PURE__*/_jsx(StyledNavButton, _objectSpread(_objectSpread({
      twStyle: twStyle,
      isDropdownItem: isDropdownItem,
      onClick: onClick,
      isActive: isActive,
      href: href,
      isHover: isHover,
      as: !!href && !!Link ? Link : undefined,
      "data-cy": testId
    }, rest), {}, {
      children: children
    })), /*#__PURE__*/_jsx(HoverLine, {
      isHover: isHover,
      isDropdownItem: isDropdownItem
    })]
  });
};

var HoverLine = /*#__PURE__*/_styled.span.withConfig({
  displayName: "buttonnavigation__HoverLine",
  componentId: "sc-h7vgr3-0"
})(function (_ref2) {
  var isDropdownItem = _ref2.isDropdownItem,
      isHover = _ref2.isHover;
  return [{
    "marginLeft": "auto",
    "marginRight": "auto",
    "display": "block",
    "width": "66.666667%",
    "borderBottomWidth": "1.5px",
    "borderColor": "transparent",
    "transitionProperty": "all",
    "transitionTimingFunction": "linear",
    "transitionDuration": "200ms"
  }, isHover && !isDropdownItem && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(142 105 206 / var(--tw-border-opacity))"
  }];
});

var StyledNavButton = /*#__PURE__*/_styled.a.withConfig({
  displayName: "buttonnavigation__StyledNavButton",
  componentId: "sc-h7vgr3-1"
})(["", " ", " ", " ", " ", " ", ""], {
  "display": "block",
  "cursor": "pointer",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))",
  "transitionProperty": "color",
  "transitionTimingFunction": "linear",
  "transitionDuration": "200ms"
}, {
  "@media (min-width: 1024px)": {
    "width": "fit-content",
    "fontSize": "1rem",
    "lineHeight": "1.5rem"
  }
}, function (_ref3) {
  var isDropdownItem = _ref3.isDropdownItem,
      isActive = _ref3.isActive;
  return isDropdownItem ? [{
    "display": "flex",
    "width": "100%",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "gap": "0.5rem",
    "paddingLeft": "1rem",
    "paddingRight": "1rem",
    "paddingTop": "0.75rem",
    "paddingBottom": "0.75rem",
    "fontSize": "1rem",
    "lineHeight": "1.25rem"
  }, isActive ? {
    "width": "100%",
    "borderRadius": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(55 65 81 / var(--tw-text-opacity))",
    "@media (min-width: 1024px)": {
      "width": "100%"
    }
  } : {}] : {};
}, function (_ref4) {
  var isHover = _ref4.isHover;
  return isHover ? {
    "--tw-text-opacity": "1",
    "color": "rgb(142 105 206 / var(--tw-text-opacity))"
  } : {};
}, function (_ref5) {
  var noPadding = _ref5.noPadding;
  return noPadding ? {
    "paddingLeft": "0px",
    "paddingRight": "0px",
    "paddingTop": "2.25rem",
    "paddingBottom": "2.25rem"
  } : {};
}, function (_ref6) {
  var twStyle = _ref6.twStyle;
  return twStyle;
});